import { httpGet } from "@cirrus/core/http"
import { News, NewsService } from "./types"
import { FrontendConfig } from "../../../FrontendConfig/types"

export class Http implements NewsService {
  private customer: FrontendConfig["Customer"] | null = null

  getNews = async () => {
    if (!this.customer) throw new Error("Customer not found")
    return httpGet(`/api/v1/customer/${this.customer}/news`)
  }

  constructor(customer: FrontendConfig["Customer"]) {
    this.customer = customer
  }
}

export class Mock implements NewsService {
  private news: News | null = null
  
  constructor(news?: News) {
    news && (this.news = news)
  }
  
  getNews = async () => ({ data: this.news })
}
